import React, { useEffect, useState } from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import { ProgressBar, StarRating } from "../../../components";
import { colors } from "../../../constants/colors";
import { StyleSheet } from "../../../models/StyleSheet";
import cssStyle from "./styles/reviewItem.module.css";
import { Avatar, Col, Row, Input } from "antd";
import { CommentDots } from "../../../assets";
import { reviewsInterface } from "../../../hooks/api/Reviews";

import { EnvironmentOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "../../../index.css";
import { storage } from "../../../services/storage";
import { toFixedNoRounding } from "../../../utils/numbers";
// import { QueryInterface } from "..";
dayjs.extend(relativeTime);

const sekFormatter = new Intl.NumberFormat("sv-SE", {
  style: "currency",
  currency: "SEK",
});

export const ReviewItem = ({ review }: { review: reviewsInterface }) => {
  const { t } = useTranslation("reviewPage");
  const { t: tSupplierReviews } = useTranslation("supplierReviews");

  return (
    <div style={styles.container}>
      <div className="reviewRow" style={styles.review}>
        <Row style={styles.reviewHeader}>
          <Col span={6}>
            <div style={styles.userInfo}>
              <Avatar size={45}>{review.buyer?.user.firstName[0] || ""}</Avatar>
              <div style={styles.userInfoText}>
                <div style={styles.name}>
                  {`${review.buyer?.user.firstName || ""} ${
                    review.buyer?.user.lastName || ""
                  }`}
                </div>
                <div style={styles.userInfoSmall}>{review.buyer?.position}</div>
                <div style={styles.userInfoSmall}>
                  {review.buyer?.user?.credentials?.email}
                </div>
              </div>
            </div>
            {/* <div style={styles.name}> {JSON.stringify(review)}</div> */}
          </Col>
          <Col span={18}>
            <Row className={cssStyle.reviewHeader}>
              <Col span={8} style={{ marginBottom: "20px" }}>
                <div style={styles.ratingContainer}>
                  <span style={styles.rating}>
                    <StarRating
                      style={styles.rate}
                      color={colors.primary}
                      disabled={true}
                      size={24}
                      value={review.overallRating}
                    />
                  </span>
                  <span style={styles.heading}>
                    {isNaN(review.overallRating)
                      ? "0.00"
                      : toFixedNoRounding(review.overallRating, 2)}
                  </span>
                </div>
              </Col>
              <Col style={styles.verticalCenter} span={8}>
                <span style={styles.createdAt}>
                  {dayjs(review.createdAt).format("YYYY-MM-DD")}
                </span>
              </Col>
              <Col style={styles.center} span={4}>
                <EnvironmentOutlined
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "18px",
                    color: "rgba(0, 0, 0, 0.85)",
                  }}
                />
                <span style={styles.location}>
                  {review.buyer !== undefined || null
                    ? review.buyer?.community
                    : t("informationMissing")}
                </span>
              </Col>
              <Col span={4} style={{ textAlign: "right" }}></Col>
            </Row>
            <Row>
              <Col md={12} lg={8}>
                <div style={styles.subContainer}>
                  <ProgressBar
                    className={cssStyle.progressbar}
                    label={tSupplierReviews("quality")}
                    rate={review.qualityRating}
                  />
                  <ProgressBar
                    className={cssStyle.progressbar}
                    label={tSupplierReviews("sustainability")}
                    rate={review.sustainabilityRating}
                  />
                </div>
              </Col>
              <Col md={12} lg={8}>
                <div style={styles.subContainer}>
                  <ProgressBar
                    className={cssStyle.progressbar}
                    label={tSupplierReviews("deliveryCapacity")}
                    rate={review.deliverCapacity}
                  />
                  <ProgressBar
                    className={cssStyle.progressbar}
                    label={tSupplierReviews("customerService")}
                    rate={review.customerServiceRating}
                  />
                </div>
              </Col>
              <Col md={12} lg={8}>
                <div style={styles.subContainer}>
                  <ProgressBar
                    className={cssStyle.progressbar}
                    label={tSupplierReviews("cost")}
                    rate={review.pricingRating}
                  />
                  <ProgressBar
                    className={cssStyle.progressbar}
                    label={tSupplierReviews("innovation")}
                    rate={review.innovationRating}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <div style={styles.commentBox}>
        <div style={styles.agreement}>
          <div style={styles.agreementRow}>
            Avtal: {review.agreement?.identifier || "-"}
          </div>
          <div style={styles.agreementRow}>
            Avtalets värde:{" "}
            {review.agreement?.estimatedValue &&
            review.agreement?.estimatedValue > 0
              ? sekFormatter.format(review.agreement?.estimatedValue)
              : "-"}
          </div>
          <div style={styles.agreementRow}>
            Avtalets period:{" "}
            {review.agreement?.startDate
              ? dayjs(review.agreement?.startDate).format("YYYY-MM-DD")
              : ""}{" "}
            -{" "}
            {review.agreement?.endDate
              ? dayjs(review.agreement?.endDate).format("YYYY-MM-DD")
              : ""}
          </div>
        </div>
        <div style={styles.comment}>{review.text}</div>
      </div>
    </div>
  );
};
const styles = StyleSheet.create({
  agreement: {
    width: "500px",
    fontSize: "14px",
    marginBottom: "20px",
  },
  agreementRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  container: {
    margin: "0px 0px 18px 0px",
  },
  center: {
    display: "flex",
  },
  comment: {
    marginBottom: "25px",
  },
  likeFilledIcon: {
    fontSize: "20px",
    color: "#07285D",
    marginRight: "10px",
  },
  likeOutlinedIcon: {
    fontSize: "20px",
    color: "#808795",
    marginRight: "10px",
  },
  likeText: {
    fontFamily: "d-din",
    fontWeight: "400",
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "15px",
    letterSpacing: "0.07em",
    color: "#808795",
    cursor: "pointer",
  },
  review: {
    width: "100%",
    // height: "64px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    padding: "25px",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
  },
  reviewHeader: {
    width: "100%",
  },
  verticalCenter: {
    paddingTop: "10px",
  },
  numberCol: {
    paddingTop: "3px",
  },
  userInfo: {
    marginTop: "25px",
    display: "flex",
  },
  userInfoText: {
    marginTop: "10px",
    marginLeft: "20px",
  },
  userInfoSmall: {
    fontFamily: "d-din",
    fontWeight: "400",

    fontSize: "14px",
    lineHeight: "12px",
    letterSpacing: "0.07em",
    marginBottom: "8px",
    maxWidth: "185px",
    wordWrap: "break-word",
  },
  name: {
    fontFamily: "d-din",
    fontWeight: "500",

    fontSize: "16px",
    lineHeight: "15px",
    letterSpacing: "0.07em",
    marginBottom: "30px",
  },
  location: {
    fontFamily: "d-din",
    fontWeight: "400",
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "13px",
    letterSpacing: "0.07em",
    color: "rgba(0, 0, 0, 0.55)",
    marginLeft: "15px",
    display: "flex",
    alignItems: "center",
  },
  rate: {},

  rateNumber: {
    fontFamily: "d-din",
    fontWeight: "400",
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "17px",
    letterSpacing: "0.07em",
    height: "31.42px",
    color: colors.primary,
    marginLeft: "10px",
    marginBottom: "3px",
  },
  createdAt: {
    color: "#000000",
    marginLeft: "1ch",
    fontFamily: "d-din",
    fontWeight: "400",
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "15px",
    letterSpacing: "0.07em",
  },
  commentBox: {
    padding: "25px 25px 25px 30px",
    fontFamily: "d-din",
    fontWeight: "400",
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "118.1%",
    letterSpacing: "0.07em",
    wordBreak: "break-word",
    backgroundColor: "#FFFFFF",
    margin: "1px 0px 0px 0px",
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
  },
  subContainer: {
    margin: "0px 0px 10px 0px",
  },

  ratingContainer: {
    display: "flex",
    alignItems: "center",
  },

  rating: {
    paddingTop: "8px",
    marginRight: "15px",
  },

  heading: {
    fontFamily: "D-DIN",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "18px",
    letterSpacing: "0.07em",
    color: "#07285D",
    display: "inline-block",
  },
});
